module.exports = __webpack_public_path__ + "img/signbgafter.d5007da6.jpg";